import { render, staticRenderFns } from "./FlowRecover.vue?vue&type=template&id=64da2a4a&scoped=true"
import script from "./FlowRecover.vue?vue&type=script&lang=js"
export * from "./FlowRecover.vue?vue&type=script&lang=js"
import style0 from "./FlowRecover.vue?vue&type=style&index=0&id=64da2a4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da2a4a",
  null
  
)

export default component.exports